<div class="d-flex align-items-center min-vh-100" role="main">
	<div class="container">
		<div class="row">
			<div class="col-12 text-center">
				<h3>
					<span i18n="page not found main header|title conveying that some navigation has gone wrong"
						>Something just Zoned out!</span
					>
				</h3>
				<h2 i18n="page not found sub header|the page not found error sub header">404 Not Found Error</h2>
				<div class="error-details mb-3">
					<span i18n="page not found error|message telling user the requested page is not found"
						>Sorry, requested page not found!</span
					>
				</div>
				<div>
					<button mat-flat-button color="primary" (click)="navigate()">
						<span i18n="navigate to exisitng page button title">Go Somewhere Real</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
